import React from "react";
import { HeroVideoSliceFragment } from "../../types/graphql";
import {
  HeroVimeoBase,
  HeroVimeoContainer,
  HeroVimeoContent,
  HeroVimeoTitle,
  HeroVimeoDescription,
  HeroVimeoEmbed,
  StyledCTA,
} from "./hero-vimeo.styled";
import { PrismicRichText } from "@prismicio/react";

interface IHeroVideoProps {
  hero: HeroVideoSliceFragment;
}

const HeroVimeo = (props: IHeroVideoProps) => {
  const hero = props.hero.primary;

  return (
    <HeroVimeoBase>
      <HeroVimeoContainer>
        <HeroVimeoContent>
          {hero.title && <HeroVimeoTitle>{hero.title}</HeroVimeoTitle>}
          {hero.subtitle && (
            <HeroVimeoDescription>
              <PrismicRichText
                field={hero?.subtitle?.richText}
                components={{
                  paragraph: ({ children }) => (
                    <p className="intro">{children}</p>
                  ),
                }}
              />
            </HeroVimeoDescription>
          )}
          {hero.vimeo && (
            <HeroVimeoEmbed>
              {hero.vimeo.embed_url && (
                <iframe
                  className="rounded-xl"
                  width="100%"
                  height="100%"
                  src={hero.vimeo.embed_url}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </HeroVimeoEmbed>
          )}
          {hero.cta_text && (
            <StyledCTA
              kind="primary"
              scale="xlarge"
              pageSection="hero-video"
              ctaText={hero.cta_text}
              action={hero.cta_action}
              linkURL={hero.cta_link && hero.cta_link.url}
              target={hero.cta_link && hero.cta_link.target}
            />
          )}
        </HeroVimeoContent>
      </HeroVimeoContainer>
    </HeroVimeoBase>
  );
};

export default HeroVimeo;
